<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-5">Rinkmenos</h3>

    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat v-if="bylos_segamos && !isReadonlyForm">
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <el-button-prideti
            v-if="showAddRinkmenos"
            :primary="pridetiColor"
            @click.native.stop="newItem()"
          >
            Prisegti rinkmeną
          </el-button-prideti>
        </v-toolbar>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @editItem="editItem(item)"
            @deleteItem="deleteItem(item)"
            @restoreItem="restoreItem(item)"
          />
        </div>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <hipoteka-istorija duomenys="rinkmenos" />

    <modal-upload
      v-model="showUpload"
      :upload="modalUpload"
      :key="modalUploadKey"
      :multiple="false"
      :bylos-rusys="bylos_rusys"
      :max-dydis="rinkmenaDydis"
      @savedData="savedUpload"
    />

    <modal-delete
      title="Šalinti rinkmeną?"
      :text="
        `Ar norite pašalinti rinkmeną <strong>${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />

    <v-footer class="form-footer">
      <v-spacer></v-spacer>
      <el-button
        v-if="!isReadonlyForm"
        primary
        @click.native="checkErrors()"
        :loading="loading"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from './hipotekaMap'
import userRole from '../../mixins/userRole'
import busena from '../../mixins/busena'
import ModalUpload from '../modals/ModalUpload'
import ModalDelete from '../modals/ModalDelete'
import checkErrors from '../../mixins/checkErrors'
import HipotekaIstorija from './istorija/HipotekaIstorija'

export default {
  name: 'HipotekaRinkmenos',
  components: {
    HipotekaIstorija,
    ModalUpload,
    ModalDelete,
  },
  mixins: [userRole, busena, checkErrors],
  props: {
    readonlyForm: { type: Boolean, default: false },
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      showUpload: false,

      modalUploadRefresh: 0,
      modalUpload: {},
      rinkmenaDydis: null,
      salys: [],
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      bylos: [],
      bylos_rusys: [],
      bylos_segamos: false,
      obj_dokumento_numeris: null,
      obj_dokumento_data: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'hipotekaTipas',
      'turtasID',
      'hipotekaReadonly',
    ]),
    isReadonlyForm() {
      return this.hipotekaReadonly || this.readonlyForm
    },
    headers() {
      return [
        {
          text: 'Rūšis',
          align: 'start',
          value: 'byl_rusis',
        },
        {
          text: 'Dokumento Nr.',
          align: 'start',
          value: 'byl_dokumento_nr',
        },
        {
          text: 'Dokumento data',
          align: 'start',
          value: 'byl_dokumento_data',
        },
        {
          text: 'Sukūrimo data',
          align: 'start',
          value: 'byl_sukurimo_data',
        },
        {
          text: 'Failo pavadinimas',
          align: 'start',
          value: 'byl_pavadinimas',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.bylos.map(item => {
        item.byl_tipas = 'download'
        item.byl_url = `byla/${item.byl_id}/${item.byl_hash}/content`
        item.canDownload = item.byl_pavadinimas != null
        item.canEdit = this.bylos_segamos && !this.isReadonlyForm
        item.canDelete = this.isRengiamas || this.isGrazintas
        return item
      })
    },
    pridetiColor() {
      return !this.turtas
    },
    modalUploadKey() {
      return 'upload' + this.modalUploadRefresh
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    showRinkmenos() {
      return true
    },
    showAddRinkmenos() {
      return this.isRengiamas || this.isGrazintas || this.isPerduotas
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(`objektas/${this.objektasID}/byla`)
        .then(res => {
          this.bylos = res.data.bylos
          this.bylos_rusys = res.data.bylos_rusys
          this.bylos_segamos = res.data.bylos_segamos
          this.obj_dokumento_numeris = res.data.obj_dokumento_numeris
          this.obj_dokumento_data = res.data.obj_dokumento_data
          this.rinkmenaDydis = parseInt(res.data.rinkmena_dydis)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    editItem(item) {
      this.openUpload(item)
    },
    newItem() {
      this.openUpload({
        byl_dokumento_nr: this.obj_dokumento_numeris,
        byl_dokumento_data: this.obj_dokumento_data,
      })
    },
    openUpload(item) {
      this.modalUpload = {
        ...item,
      }
      this.modalUploadRefresh++
      this.showUpload = true
    },
    savedUpload() {
      this.getData()
    },
    deleteItem(item) {
      this.modalDeleteVardas = item.byl_pavadinimas
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`objektas/${this.objektasID}/byla/${item.byl_id}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
